import { make } from 'vuex-pathify'
import format from '@/common/dateFormat'
import { eachDay, getISODay } from 'date-fns'

const state = {
  dateStart: null,
  dateEnd: null,
  tekniskttagnummer: '',
  selectedDateCell: null
}

const mutations = make.mutations(state)

const getters = {
  days(state) {
    if (!state.dateStart || !state.dateEnd) return []
    return eachDay(state.dateStart, state.dateEnd).map(date => ({
      dayFormatted: format(date, 'dd'),
      date
    }))
  },

  totalWeeks(state, getters) {
    return Math.ceil(
      Math.max(...getters['months'].map(month => month.days.length)) / 7
    )
  },

  months(state, getters, rootState) {
    const trainSchedule = rootState.trainSchedule.all
    return getters['days'].reduce((acc, day, i) => {
      const { date, dayFormatted } = day
      const dayObj = {
        dayOfMonth: format(date, 'DD'),
        dayOfWeek: getISODay(date),
        dayFormatted,
        date,
        schedule: trainSchedule[format(date)] || null
      }
      const month = format(date, 'MMMM')
      let year = format(date, 'YY')
      const prev = acc[acc.length - 1]
      if (month !== 'januari' && i !== 0) year = null

      if (prev && prev.month === month) {
        prev.days = [...prev.days, dayObj]
        return acc
      }

      acc = [...acc, { month, year, days: [dayObj] }]
      return acc
    }, [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
